/**
 * Cart Iraq Regions Data — Governorates & Delivery Rules
 * Single source of truth. Used by: header picker, PDP delivery card, cart, shipping estimator.
 * Delivery: flat 5,000 IQD to all 18 governorates.
 *   Baghdad: 24-48 hours · Other governorates: 48-72 hours.
 */
window.__JOCELL_REGIONS = {
  defaultCountry: "iq",
  defaultGov: "baghdad",
  countries: {
    iq: {
      name_ar: "العراق", name_en: "Iraq", flag: "🇮🇶", code: "IQ", currency: "IQD",
      currency_ar: "د.ع", currency_en: "IQD",
      governorates: {
        baghdad: { name_ar:"بغداد", name_en:"Baghdad", zone:"capital", fee:5000, hours_min:24, hours_max:48, days_min:1, days_max:2, same_day:false, cod:true },
        basra: { name_ar:"البصرة", name_en:"Basra", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        nineveh: { name_ar:"نينوى", name_en:"Nineveh", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        erbil: { name_ar:"أربيل", name_en:"Erbil", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        sulaymaniyah: { name_ar:"السليمانية", name_en:"Sulaymaniyah", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        duhok: { name_ar:"دهوك", name_en:"Duhok", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        kirkuk: { name_ar:"كركوك", name_en:"Kirkuk", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        anbar: { name_ar:"الأنبار", name_en:"Anbar", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        babil: { name_ar:"بابل", name_en:"Babil", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        karbala: { name_ar:"كربلاء", name_en:"Karbala", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        najaf: { name_ar:"النجف", name_en:"Najaf", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        diyala: { name_ar:"ديالى", name_en:"Diyala", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        wasit: { name_ar:"واسط", name_en:"Wasit", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        saladin: { name_ar:"صلاح الدين", name_en:"Saladin", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        qadisiyyah: { name_ar:"القادسية", name_en:"Al-Qadisiyyah", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        maysan: { name_ar:"ميسان", name_en:"Maysan", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        dhiqar: { name_ar:"ذي قار", name_en:"Dhi Qar", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true },
        muthanna: { name_ar:"المثنى", name_en:"Muthanna", zone:"other", fee:5000, hours_min:48, hours_max:72, days_min:2, days_max:3, same_day:false, cod:true }
      }
    }
  },
  // Helper methods
  getCountry: function(code) { return this.countries[code] || this.countries.iq; },
  getGov: function(country, gov) {
    var c = this.getCountry(country);
    return c ? (c.governorates[gov] || null) : null;
  },
  getName: function(country, gov, lang) {
    var g = this.getGov(country, gov);
    return g ? g['name_' + lang] : '';
  },
  getCountryName: function(code, lang) {
    var c = this.getCountry(code);
    return c ? c['name_' + lang] : '';
  },
  // "24-48 ساعة" / "24-48 hours"
  etaText: function(gov, lang) {
    var g = this.getGov('iq', gov) || this.getGov('iq', 'baghdad');
    var r = g.hours_min + '-' + g.hours_max;
    return lang === 'ar' ? ('خلال ' + r + ' ساعة') : ('Within ' + r + ' hours');
  },
  fmtIQD: function(v, lang) {
    return Math.round(Number(v) || 0).toLocaleString('en-US') + ' ' + (lang === 'ar' ? 'د.ع' : 'IQD');
  }
};
